interface MessageDialogProps {
  message: string;
  onOk: () => void;
  onCancel?: () => void;
  showCancel?: boolean;
  okText?: string;
  cancelText?: string;
}

export default function MessageDialog({
  message,
  onOk,
  onCancel,
  showCancel = true,
  okText = "OK",
  cancelText = "Cancel",
}: MessageDialogProps) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm mx-auto my-auto animate-fade-in">
        <p className="text-gray-800 text-center mb-6 text-base leading-relaxed">{message}</p>

        <div className={`flex ${showCancel ? 'justify-between' : 'justify-center'} gap-4`}>
          {showCancel && onCancel && (
            <button
              className="flex-1 bg-[#9E9E9E] hover:bg-[#757575] text-white py-3 rounded-lg transition-colors font-medium"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}

          <button
            className={`${showCancel ? 'flex-1' : 'min-w-[120px]'} bg-brand-primary hover:bg-brand-hover text-white py-3 rounded-lg transition-colors font-medium`}
            onClick={onOk}
          >
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
}
